const isAllowedMimeType = (type) => ["image/webp", "image/svg+xml", "image/tiff", "image/svg+xml", "image/png", "image/jpeg", "image/jpg"].includes(type);
const maybeLegacyToolbarIcon = (appd) => {
    const legacyToolbarConfig = appd?.hostManifests?.Finsemble?.foreign?.components?.Toolbar;
    const legacyToolbarIconAsURL = legacyToolbarConfig?.iconURL
        ? {
            imageType: "url",
            path: legacyToolbarConfig.iconURL,
        }
        : undefined;
    return legacyToolbarIconAsURL;
};
const appDIconSrc = (icon) => {
    const src = icon.src ?? icon.url ?? icon.icon;
    return src ?? "";
};
const pickAppDIconBySize = (iconsConfig) => {
    const best = iconsConfig.sort((a, b) => {
        if (a.sizes && b.sizes) {
            const aDiff = parseInt(a.sizes, 10) - 16;
            const bDiff = parseInt(b.sizes, 10) - 16;
            return Math.abs(aDiff) - Math.abs(bDiff);
        }
        if (a.sizes && !b.sizes) {
            return -1;
        }
        if (b.sizes && !a.sizes) {
            return 1;
        }
        return 0;
    })[0];
    return {
        imageType: "url",
        path: appDIconSrc(best),
    };
};
const absolutePath = (src, appd) => {
    if (!src) {
        return src;
    }
    const appURL = appd?.details?.url ?? appd?.hostManifests?.Finsemble?.window?.url;
    if (!appURL) {
        return src;
    }
    if (src.includes("http://") || src.includes("https://")) {
        return src;
    }
    try {
        const resolvedURL = new URL(src, appURL);
        return resolvedURL.href;
    }
    catch (e) {
        return src;
    }
};
const isTaskbarCompatible = (icon) => {
    if (!icon?.src) {
        return false;
    }
    const path = icon.src.toLowerCase();
    return path.endsWith(".png") || path.endsWith(".jpg") || path.endsWith(".jpeg") || path.endsWith(".ico");
};
const isWebCompatible = (icon) => {
    if (!icon?.src) {
        return true;
    }
    if (icon?.type) {
        return isAllowedMimeType(icon.type);
    }
    const path = icon.src.toLowerCase();
    try {
        const iconURL = new URL(path);
        return iconURL.search
            ? !iconURL.search.includes(".ico") && !iconURL.search.includes(".icns")
            : !path.endsWith(".ico") && !path.endsWith(".icns");
    }
    catch (error) {
        return false;
    }
};
const maybeGetAppDIcon = (appd, compatibility) => {
    const iconsConfig = appd?.icons ?? [];
    if (!iconsConfig) {
        return;
    }
    const compatibleIcons = iconsConfig.filter((icon) => {
        if (compatibility === "taskbar" && isTaskbarCompatible(icon)) {
            return true;
        }
        return compatibility === "web" && isWebCompatible(icon);
    });
    if (compatibleIcons.length === 0) {
        return;
    }
    if (compatibleIcons.length === 1) {
        return {
            imageType: "url",
            path: absolutePath(appDIconSrc(compatibleIcons[0]), appd),
        };
    }
    return pickAppDIconBySize(compatibleIcons);
};
const iconsFromAppConfig = (appd) => {
    const displayName = appd?.title ?? appd?.hostManifests?.Finsemble?.component?.displayName ?? appd?.name ?? appd?.appId;
    const initialsIcon = {
        imageType: "initials",
        name: displayName ?? "",
    };
    const iconFromAppD = maybeGetAppDIcon(appd, "web");
    const iconFromAppDForTaskbar = maybeGetAppDIcon(appd, "taskbar");
    const legacyToolbarIcon = maybeLegacyToolbarIcon(appd);
    const toolbarIcon = legacyToolbarIcon ?? iconFromAppD ?? initialsIcon;
    const titleBarIcon = legacyToolbarIcon ?? iconFromAppD ?? initialsIcon;
    const ifURL = (icon) => (icon?.imageType === "url" ? icon : undefined);
    const taskbarIcon = ifURL(legacyToolbarIcon) ?? iconFromAppDForTaskbar;
    return {
        taskbarIcon,
        toolbarIcon,
        titleBarIcon,
    };
};
export const getIcons = (appd) => {
    return iconsFromAppConfig(appd);
};
